import ADB from "../../../../libs/MediaSDK";
import { akamai } from "../../../globals";
import { debug } from "@medscape/streaming-video-player/src/js/utils/debug-log";
const { Event: ADB_MEDIA_EVENTS } = ADB.Media;
const { DISPLAY_STATE_CHANGE, DESTROY } = akamai.amp.Events;

class DisplayState {
  constructor(amp, tracker, stateObjects) {
    this.amp = amp;
    this.tracker = tracker;
    this.stateObjects = stateObjects;
    this.subscriptions = [];
    this.displayState = akamai.amp.DisplayState.NORMAL;

    debug.log("[MediaAnalyticsTracking][DisplayState][constructor]:", this);
  }

  destroy() {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }
  end() {
    this.destroy();
  }
  start() {
    this.destroy();
    const { amp } = this;

    const fullscreen$ = amp.AmpEventsSources[DISPLAY_STATE_CHANGE].subscribe(
      (data) => {
        this.onDisplayStateChange(data);
      }
    );

    const destroy$ = amp.AmpEventsSources[DESTROY].subscribe((data) => {
      this.destroy();
    });
    this.subscriptions = [destroy$, fullscreen$];
    if (amp.displayState !== this.displayState) {
      this.onDisplayStateChange();
    }
  }

  trackStart() {
    const { displayState, stateObjects, tracker } = this;
    let stateObject = null;
    let stateName = ADB_MEDIA_EVENTS.StateStart;

    switch (displayState) {
      case akamai.amp.DisplayState.FULL_SCREEN:
        stateObject = stateObjects.FullScreen;
        break;
      case akamai.amp.DisplayState.PICTURE_IN_PICTURE:
        stateObject = stateObjects.PictureInPicture;
        break;
    }
    if (stateObject != null) {
      debug.log(
        "[MediaAnalyticsTracking][DisplayState][trackStart] tracker.trackEvent \n\tstateName:",
        stateName,
        "\n\tstateObject:",
        stateObject
      );
      tracker.trackEvent(stateName, stateObject);
    }
  }
  trackEnd() {
    const { displayState, stateObjects, tracker } = this;
    let stateObject = null;
    let stateName = ADB_MEDIA_EVENTS.StateEnd;
    switch (displayState) {
      case akamai.amp.DisplayState.FULL_SCREEN:
        stateObject = stateObjects.FullScreen;
        break;
      case akamai.amp.DisplayState.PICTURE_IN_PICTURE:
        stateObject = stateObjects.PictureInPicture;
        break;
    }
    if (stateObject != null) {
      debug.log(
        "[MediaAnalyticsTracking][DisplayState][trackEnd] tracker.trackEvent \n\tstateName:",
        stateName,
        "\n\tstateObject:",
        stateObject
      );
      tracker.trackEvent(stateName, stateObject);
    }
  }
  onDisplayStateChange(data) {
    this.trackEnd();
    this.displayState = this.amp.displayState;
    this.trackStart();
  }
}

export default DisplayState;
